import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { CustomModalService } from '../components/custom-modal/custom-modal';

@Injectable()
export class ModalService {
  constructor(private dialog: MatDialog) {}

  open(data: any) {
    const config: MatDialogConfig = new MatDialogConfig();
    config.data = {
      title: data.title,
      content: data.content,
      cancel: data.cancel,
      imageSrc: data.imageSrc,
    };
    this.dialog.open(CustomModalService, config);
  }
}
